import cx from 'classnames'

import { InsideInputIconButton } from '../../internal/insideInputIconButton/InsideInputIconButton'

type Props = {
  isInError: boolean
  isDisabled: boolean
}
export const DateButton = ({ isDisabled, isInError }: Props) => (
  <InsideInputIconButton
    tip={null}
    iconName="Calendar"
    isDisabled={isDisabled}
    className={cx(
      'focus-visible:inset-shadow-none!', // Remove default focus ring. TODO - add custom variant for iconbutton to handle this once we have more buttons inside inputs (i.e. when we make the new combobox)
      isInError ? 'focus-visible:bg-error/20' : 'focus-visible:bg-primary/20',
    )}
  />
)
